/** @format */

import type { Brand } from "@question-bank/shared";
import { createContext } from "react";

interface BrandContextProps {
	brand: Brand;
	setBrand: (brand: Brand) => void;
}
export const BrandContext = createContext<BrandContextProps | undefined>(undefined);
